import React from "react";
import { Button, Stack, styled } from "@mui/material";
import { Link } from "react-router-dom";

const StyledStack = styled(Stack)`
  flex-direction: row;
  justify-content: end;
  margin-top: 30px;
  gap: 20px;
`;

const TablePageButtons = ({
  currentPage,
  hasNextPage,
  onPageButtonClicked,
}) => {
  const prevPage = currentPage - 1;
  const nextPage = currentPage + 1;

  const handlePrevPageClicked = () => onPageButtonClicked(prevPage);
  const handleNextPageClicked = () => onPageButtonClicked(nextPage);

  return (
    <StyledStack>
      {currentPage > 0 && <Button
        component={Link}
        to={`?page=${prevPage}`}
        variant="contained"
        onClick={handlePrevPageClicked}
      >
        Prev
      </Button>}
      {hasNextPage && <Button
        component={Link}
        to={`?page=${nextPage}`}
        variant="contained"
        onClick={handleNextPageClicked}
      >
        Next
      </Button>}
    </StyledStack>
  );
};

export default TablePageButtons;